export const Ten = () => {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="42" height="32" viewBox="0 0 42 32">
<path d="M2.667 0h20.667c1.473 0 2.667 1.194 2.667 2.667v26.667c0 1.473-1.194 2.667-2.667 2.667h-20.667c-1.473 0-2.667-1.194-2.667-2.667v-26.667c0-1.473 1.194-2.667 2.667-2.667z"></path>
<path d="M31.334 0c1.472 0 2.666 1.194 2.666 2.666v26.668c-0 1.472-1.194 2.666-2.666 2.666h-5.334c1.473 0 2.666-1.194 2.666-2.666v-26.668c-0-1.472-1.193-2.666-2.666-2.666h5.334z"></path>
<path d="M39.334 0c1.472 0 2.666 1.194 2.666 2.666v26.668c-0 1.472-1.194 2.666-2.666 2.666h-5.334c1.473 0 2.666-1.194 2.666-2.666v-26.668c-0-1.472-1.193-2.666-2.666-2.666h5.334z"></path>
</svg>
    );
};
